import React from "react"
import { useTranslation } from "react-i18next"

import { BuildingType } from "shared/types/references/BuildingType"
import { RoomType } from "shared/types/references/RoomType"
import { ChipList } from "shared/ui/chip-list/ChipList"

import { ReferenceFilterChip } from "./ReferenceFilterChip"
import "./styles/_reference-filter-chip-list.scss"
import {
  ReferenceFilterItem,
  ReferenceFilterType
} from "./types/ReferenceFilterType"

type ValueByFilterType<FilterType extends ReferenceFilterType> =
  FilterType extends typeof ReferenceFilterType.BUILDING_TYPE
    ? BuildingType
    : FilterType extends typeof ReferenceFilterType.ROOM_TYPE
    ? RoomType
    : string

export type OnRemoveReferenceFilter<
  FilterType extends ReferenceFilterType = ReferenceFilterType
> = (filterType: FilterType, value: ValueByFilterType<FilterType>) => void

export interface ReferenceFilterChipListViewModel {
  chips: ReferenceFilterItem[]
  onRemove: OnRemoveReferenceFilter
}

export const ReferenceFilterChipListView = React.memo(
  ({ chips, onRemove }: ReferenceFilterChipListViewModel) => {
    const { t } = useTranslation()

    return (
      <ChipList.List
        aria-label={t("Filter.ActiveFilters")}
        className="reference-filter-chip-list"
      >
        {chips.map(chip => (
          <ReferenceFilterChip key={chip.key} chip={chip} onRemove={onRemove} />
        ))}
      </ChipList.List>
    )
  }
)
ReferenceFilterChipListView.displayName = "ReferenceFilterChipListView"
